module.exports = __webpack_public_path__ + "static/media/arrow-down.f8cc9c9c.svg";